var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99996 7.66656L5.33329 8.9999L8.33329 5.99988M11.3333 7.9999C11.3333 11.2722 7.76396 13.6522 6.46529 14.4098C6.31769 14.4959 6.24389 14.539 6.13976 14.5613C6.05889 14.5786 5.94103 14.5786 5.86016 14.5613C5.75603 14.539 5.68223 14.4959 5.53463 14.4098C4.23593 13.6522 0.666626 11.2722 0.666626 7.9999V4.81161C0.666626 4.2786 0.666626 4.0121 0.753799 3.78301C0.830806 3.58064 0.955946 3.40006 1.1184 3.25689C1.30229 3.09483 1.55183 3.00126 2.05089 2.81411L5.62543 1.47366C5.76403 1.42168 5.83329 1.3957 5.90463 1.3854C5.96783 1.37626 6.03209 1.37626 6.09529 1.3854C6.16663 1.3957 6.23589 1.42168 6.37449 1.47366L9.94903 2.81411C10.4481 3.00126 10.6976 3.09483 10.8815 3.25689C11.044 3.40006 11.1691 3.58064 11.2461 3.78301C11.3333 4.0121 11.3333 4.2786 11.3333 4.81161V7.9999Z",
    stroke: "#000000",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuard);
export default __webpack_public_path__ + "static/media/guard.36ef1292cb545e8505f030093e1a1ce5.svg";
export { ForwardRef as ReactComponent };